import { WeatherMain } from "api/event";
import ClearIcon from "./clear.svg?url";
import CloudsIcon from "./clouds.svg?url";
import RainIcon from "./rain.svg?url";
import SnowIcon from "./snow.svg?url";
import ThunderstormIcon from "./thunderstorm.svg?url";

export const weatherIcons: { [K in WeatherMain]: string } = {
  Clear: ClearIcon,
  Clouds: CloudsIcon,
  Drizzle: CloudsIcon,
  Rain: RainIcon,
  Snow: SnowIcon,
  Thunderstorm: ThunderstormIcon,
  Unknown: CloudsIcon,
};

export const weatherIconsLabels: { [K in WeatherMain]: string } = {
  Clear: "clear",
  Clouds: "clouds",
  Drizzle: "drizzle",
  Rain: "rain",
  Snow: "snow",
  Thunderstorm: "thunderstorm",
  Unknown: "clouds",
};
